import {
  REACT_APP_LOG_PROXY_ENDPOINT,
  REACT_APP_LOG_SOURCE_CATEGORY,
} from './configs';

export interface LogObject {
  message: string | Error;
  info?: string | object;
}

type LogLevel = 'info' | 'error';

export class Logger {
  private async sendLogToProxy(level: LogLevel, logObject: LogObject) {
    if (process.env.NODE_ENV === 'production') {
      try {
        // Attempt to get accessToken from localStorage
        let accessToken = undefined;
        const keys = Object.keys(localStorage).filter(
          x => x.startsWith('@@') && !x.endsWith('@@'),
        );
        if (keys.length > 0) {
          const item = localStorage.getItem(keys[0]);
          if (item) {
            const parsed = JSON.parse(item);
            accessToken = parsed?.body?.access_token;
          }
        }
        const body = {
          service: 'predictor-platform',
          env: REACT_APP_LOG_SOURCE_CATEGORY,
          level,
          message:
            logObject.message instanceof Error
              ? logObject.message.toString()
              : logObject.message,
          info:
            logObject.info instanceof Object
              ? { ...logObject.info }
              : { info: logObject.info },
          accessToken,
          timestamp: new Date().toISOString(),
        };
        await fetch(REACT_APP_LOG_PROXY_ENDPOINT!, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        });
      } catch (err) {
        console.error('Failed to send log to proxy endpoint', err, logObject);
      }
    } else {
      level === 'error' ? console.error(logObject) : console.log(logObject);
    }
  }

  async log(logObject: LogObject) {
    return this.sendLogToProxy('info', logObject);
  }

  async error(logObject: LogObject) {
    return this.sendLogToProxy('error', logObject);
  }
}

const logger = new Logger();
export default logger;
